module.exports = __webpack_public_path__ + "static/media/shortText.6b67c198.png";